export default __webpack_public_path__ + "static/media/classroomImg2.881a5001.svg";